import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from '../shared/Button';
export const TrustedBySection = () => {
  const companies = ['Google', 'Meta', 'Apple', 'Airbnb', 'Amazon', 'Databricks', 'Stripe'];
  return <section id="trusted-by" className="w-full bg-[#231232]/50 backdrop-blur-md py-16 border-t border-b border-[#6805DA]/20 scroll-mt-24" data-id="element-289" data-mp="16c61gi297fh6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-290" data-mp="xaew5ebmlanu">
        <div className="text-center mb-10" data-id="element-291" data-mp="sj6kebmtpd7i">
          <h3 className="text-white font-manrope text-2xl font-medium mb-4" data-id="element-292" data-mp="shc08zjdlp4h">
            Engineers from top companies trust ApplyPass
          </h3>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-8" data-id="element-293" data-mp="il0jnxcr6d48"></div>
        </div>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-8" data-id="element-294" data-mp="ei3wrug6juuh">
          {companies.map(company => <span key={company} className="text-2xl sm:text-3xl font-manrope font-bold text-gray-200 opacity-80 hover:opacity-100 transition-opacity" data-id="element-295" data-mp="9kub8pvww3bx">
              {company}
            </span>)}
          <span className="text-xl sm:text-2xl font-manrope font-bold text-gray-200 opacity-70" data-id="element-296" data-mp="2e62q9mksvz21">
            and more
          </span>
        </div>
        <div className="mt-14 text-center" data-id="element-297" data-mp="2i7xqenqzw6e8">
          <Button variant="outline" className="inline-flex items-center gap-2 font-medium" href="#testimonials" data-id="element-298" data-mp="35x8m3qthnali">
            See Client Success Stories <ArrowRightIcon size={18} data-id="element-299" data-mp="2wwasm2goelh6" />
          </Button>
        </div>
      </div>
    </section>;
};